<!-- Invoice Modal -->
<div
  class="modal fade"
  [id]="id || 'invoiceModal-' + patientRecordId"
  tabindex="-1"
  role="dialog"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  aria-labelledby="deleteModalLabel"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2" id="deleteModalLabel">
          {{ "invoice" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'close' | translate"
          (click)="closeModal()"
        ></button>
      </div>
      <div class="modal-body fs-4">
        <ng-container *ngIf="!invoiceReportGenerated">
          <div class="d-flex justify-content-center">
            <div class="spinner-border text-danger" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </ng-container>
        <div [id]="'invoiceReport-' + patientRecordId"></div>
      </div>
      <div class="modal-footer">
        <button
          (click)="downloadInvoice()"
          type="button"
          class="btn btn-sm btn-primary"
          [disabled]="!invoiceReportGenerated"
        >
          {{ "download" | translate }}
        </button>
        <button
          (click)="sendInvoice()"
          type="button"
          class="btn btn-sm btn-dark"
          [disabled]="!invoiceReportGenerated"
        >
          {{ "sendInvoice" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
